import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';

import { CommonModule } from '@angular/common';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { ShActionItemComponent } from '../action-item/action-item.component';
import { ActionItem, ActionItemIconPosition, ActionItemStyle } from '../action-item/entities/action-item.entity';
import { IconSize } from '../icon/entities/icon-sizes.entity';

@Component({
    standalone: true,
    selector: 'sh-accordion',
    templateUrl: './accordion.component.html',
    styleUrls: ['./accordion.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, ShActionItemComponent]
})
export class ShAccordionComponent implements OnInit, OnDestroy {
    private readonly destroy$: Subject<void> = new Subject<void>();
    private readonly partialToggleActionItem: Partial<ActionItem> = {
        eventListener: _ => this.toggleOpenState(),
        iconPosition: ActionItemIconPosition.Right,
        iconSize: IconSize.SMALL,
        style: ActionItemStyle.Ghost
    };

    public readonly isOpen$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    public accordionActionItem$: Observable<ActionItem>;

    @Input() openLabel: string;
    @Input() closeLabel: string;

    @Input() set isDefaultOpen(value: boolean) {
        this.isOpen$.next(!!value);
    }

    ngOnInit(): void {
        this.initAccordionActionItem();
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();

        this.isOpen$.complete();
    }

    private initAccordionActionItem(): void {
        this.accordionActionItem$ = this.isOpen$.pipe(
            takeUntil(this.destroy$),
            map(this.setAccordionActionItem.bind(this))
        );
    }

    private setAccordionActionItem(isOpen: boolean): ActionItem {
        return {
            ...(this.partialToggleActionItem as ActionItem),
            label: isOpen ? this.closeLabel : this.openLabel,
            icon: isOpen ? 'angle-up' : 'angle-down'
        };
    }

    private toggleOpenState(): void {
        this.isOpen$.next(!this.isOpen$.value);
    }
}
